import { StatusAPIResponse } from "@farcaster/auth-kit";
import { track as trackClient } from "@vercel/analytics";
import { ClientOnly } from "remix-utils/client-only";
import { useAccount as useWagmiAccount } from "wagmi";

import { FarcasterLoginButton } from "../FarcasterLoginButton/FarcasterLoginButton.client";

import { ConnectWalletButton } from "./ConnectWalletButton";
import { DisconnectWalletButton } from "./DisconnectWalletButton";
import { LoginForm } from "./LoginForm";
import { LoginOptionsSkeleton } from "./LoginOptionsSkeleton";

interface Props {
  onError: (error: string) => void;
  onFarcasterSuccess: (res: StatusAPIResponse) => void;
}

export function LoginOptions({ onError, onFarcasterSuccess }: Props) {
  const { isConnected, address } = useWagmiAccount();

  // step 1. connect wallet
  if (!isConnected) {
    return (
      <ClientOnly fallback={<LoginOptionsSkeleton />}>
        {() => (
          <div className="gap-4 flex flex-col">
            <ConnectWalletButton />
            <FarcasterLoginButton
              onSuccess={onFarcasterSuccess}
              onError={(e) => {
                console.error("Failed to log in", e);
                if (!e) {
                  return;
                }
                trackClient("failed_farcaster_auth", {
                  error: e.message,
                });
                onError(e.message);
              }}
            />
          </div>
        )}
      </ClientOnly>
    );
  }

  // step 2. connect Lens Profile and create account
  if (address) {
    return (
      <div className="gap-2 flex flex-col">
        <LoginForm owner={address} />
        <DisconnectWalletButton />
      </div>
    );
  }

  return <LoginOptionsSkeleton />;
}
